import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed } from "@vue/composition-api";
export const useApplicantFieldBindings = options => {
  const applicantIndex = computed(() => {
    return options.applicantIndex.value;
  });
  const currentApplicantPath = computed(() => {
    return applicantIndex.value === 0 ? APPLICATION_PATH.MAIN_APPLICANT : `${APPLICATION_PATH.CO_APPLICANTS}[${applicantIndex.value - 1}]`;
  });
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const applicantFromIndex = bindApplication(currentApplicantPath);
  const salutation = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][salutation]"), "");
  const firstName = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][first-name]"), "");
  const middleName = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][middle-name]"), "");
  const lastName = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][last-name]"), "");
  const email = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][email]"), "");
  const phoneNumber = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][phone-number]"), "");
  const workPhone = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][work-phone]"), "");
  const altPhoneNumber = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][alt-phone-number]"), "");
  const firstTimeHomeBuyer = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][first-time-home-buyer]"), null);
  const maritalStatus = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][marital-status]"), "");
  const dateOfBirth = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][date-of-birth]"), "");
  const numChildren = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][num-children]"), "");
  const languagePreference = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][language-preference]"), "");
  const own = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][own]"), "");
  const monthlyRent = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][monthly-rent]"), 0);
  const coApplicantType = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][co-applicant-type]"), "");
  const relationshipToMainApplicant = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][relationship-to-main-applicant]"), "");
  const addresses = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][addresses]"), []);
  const sin = bindApplication(makeFieldPathReactive(currentApplicantPath, "[personal-details][sin]"), {});
  return {
    currentApplicantPath,
    applicantFromIndex,
    salutation,
    firstName,
    middleName,
    lastName,
    email,
    phoneNumber,
    workPhone,
    altPhoneNumber,
    firstTimeHomeBuyer,
    maritalStatus,
    own,
    monthlyRent,
    numChildren,
    dateOfBirth,
    languagePreference,
    coApplicantType,
    relationshipToMainApplicant,
    addresses,
    sin
  };
};